import { useEffect, useRef } from "react";
import "./ScheduleItem.scss";

function ScheduleItem(props) {
  const scheduleImages = {
    "Recall Session": "https://quizzynow.com/images/user/schedule/1.svg",
    "Recall Session Today": "https://quizzynow.com/images/user/schedule/3.svg",
    Test: "https://quizzynow.com/images/user/schedule/2.svg",
    Flashcards: "https://quizzynow.com/images/user/schedule/4.svg",
    Quiz: "https://quizzynow.com/images/user/schedule/5.svg",
  };
  const itemRef = useRef(); // Create a ref

  useEffect(() => {
    const timer = setTimeout(() => {
      if (itemRef.current) {
        itemRef.current.style.opacity = "1";
        itemRef.current.style.marginTop = "0px";
      }
    }, 100); // delay the start of transition

    return () => clearTimeout(timer); // clean up the timer
  }, []); // the effect only runs once when the component mounts

  return (
    <div className="schedule-item" ref={itemRef}>
      <div
        className="content"
        style={
          props.onClick
            ? {
                cursor: "pointer",
              }
            : {}
        }
        onClick={() => {
          if (props.onClick) {
            props.onClick();
          }
        }}
      >
        <div className="img">
          <img
            src={scheduleImages[props.type]}
            alt={props.name}
            width={30}
            height={30}
          />
        </div>
        <div className="info">
          <h4 className="title">
            <p>{props.title}</p>
          </h4>
          <div className="row">
            <h5>{props.type}</h5>
            <h5>{props.time}</h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleItem;
